<template>
  <div
    style="position: absolute; top: 0; left: 0; background: rgba(255,255,255,.5); z-index: 5; -webkit-backdrop-filter: blur(2px); backdrop-filter: blur(2px); width: 100%; height: 100%; border-radius: 0 0 1rem 1rem;"
    :class="classList"
  ></div>
</template>

<script>
export default {
  props: {
    classList: {
      type: String
    }
  }
};
</script>5

<style></style>
